import { useEffect } from 'react'
import type { Editor } from '@tiptap/react'

/** Доводит до живого редактора пропсы, которые `useEditor` читает только на засеве. */
export const useEditorPropSync = (
  editor: Editor | null,
  { editable, placeholder }: { editable: boolean; placeholder: string },
) => {
  // Смена `editable` (заморозка статьи на проверке). Без эмита update: иначе `onChange`
  // отдал бы тот же HTML и мог пометить форму dirty.
  useEffect(() => {
    if (!editor || editor.isEditable === editable) return
    editor.setEditable(editable, false)
  }, [editable, editor])

  // Placeholder is configured via a closure over placeholderRef (extensions are static).
  // Dispatching a no-op transaction forces TipTap to re-render the placeholder when prop changes.
  useEffect(() => {
    if (!editor) return
    editor.view.dispatch(editor.state.tr)
  }, [placeholder, editor])
}
